import React from 'react';
import { useTranslation } from 'react-i18next';

const functions = [
  {
    title: 'Preparation of Master Plans',
    description: 'Preparation and revision of Master Plans, Zonal Development Plans, and Town Planning Schemes for urban areas. These plans guide the systematic growth of cities and towns by designating land uses, road networks, and development norms.',
    icon: 'ri-road-map-line',
  },
  {
    title: 'Building Permission Approvals',
    description: 'Scrutiny and approval of building permission applications for construction of residential, commercial, industrial, and institutional buildings through the APDPMS online portal.',
    icon: 'ri-building-2-line',
  },
  {
    title: 'Layout Approvals',
    description: 'Approval and regulation of residential, commercial, and industrial layouts ensuring proper infrastructure provisions including roads, drainage, water supply, open spaces, and civic amenities.',
    icon: 'ri-layout-grid-line',
  },
  {
    title: 'Development Control',
    description: 'Enforcement of development control rules and regulations to ensure planned and sustainable urban development. Monitoring construction activities and taking action against violations.',
    icon: 'ri-shield-check-line',
  },
  {
    title: 'Administration of UDAs',
    description: 'Administrative supervision and technical guidance to 21 Urban Development Authorities (UDAs) across Andhra Pradesh for effective implementation of planning functions.',
    icon: 'ri-government-line',
  },
  {
    title: 'Layout Regularisation Scheme (LRS)',
    description: 'Implementation of the Layout Regularisation Scheme for regularisation of unapproved layouts. Processing applications, verification, and granting regularisation certificates.',
    icon: 'ri-map-2-line',
  },
  {
    title: 'Building Penalisation Scheme (BPS)',
    description: 'Implementation of the Building Penalisation Scheme for regularisation of unauthorized buildings and constructions with deviations from approved plans.',
    icon: 'ri-hammer-line',
  },
  {
    title: 'Change of Land Use (CLU/NALA)',
    description: 'Processing applications for Change of Land Use from the designated zoning in Master Plans, including Non-Agricultural Land Assessment (NALA) conversions.',
    icon: 'ri-exchange-line',
  },
  {
    title: 'Transferable Development Rights (TDR)',
    description: 'Administration of the TDR scheme where development rights from one property are transferred to another, typically used for road widening and infrastructure development.',
    icon: 'ri-exchange-funds-line',
  },
  {
    title: 'Unauthorized Construction Monitoring',
    description: 'Identification, monitoring, and action against unauthorized constructions and encroachments through regular inspections and utilising technology like satellite imagery.',
    icon: 'ri-alarm-warning-line',
  },
];

export const FunctionsPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <nav className="flex items-center space-x-2 text-sm text-stone-500 mb-8">
        <a href="/" className="hover:text-amber-700 transition-colors">{t('header.home')}</a>
        <i className="ri-arrow-right-s-line text-stone-400"></i>
        <a href="/about" className="hover:text-amber-700 transition-colors">{t('header.about')}</a>
        <i className="ri-arrow-right-s-line text-stone-400"></i>
        <span className="text-stone-800 font-medium">{t('header.aboutFunctions')}</span>
      </nav>

      <div className="mb-12">
        <h1 className="text-3xl md:text-4xl font-bold text-stone-800 mb-4">Functions of DTCP</h1>
        <p className="text-lg text-stone-600 max-w-3xl">
          The Directorate of Town & Country Planning performs a wide range of functions for planned urban development and regulation of construction activities in Andhra Pradesh.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        {functions.map((fn, index) => (
          <div
            key={index}
            className="group bg-white border border-stone-200 rounded-lg p-6 hover:shadow-md hover:border-amber-300 transition-all duration-200"
          >
            <div className="flex items-start space-x-4">
              <div className="w-12 h-12 bg-amber-100 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-amber-200 transition-colors">
                <i className={`${fn.icon} w-6 h-6 flex items-center justify-center text-amber-600`}></i>
              </div>
              <div>
                <h3 className="text-stone-800 font-semibold mb-2 group-hover:text-amber-700 transition-colors">{fn.title}</h3>
                <p className="text-sm text-stone-500 leading-relaxed">{fn.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
